import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Photo from "./Photo";
import { getPhotos } from "../getPhotos";

import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";
import { useEffect, useState } from "react";


const Photos = ({t, text, lang}) => {
    const [photos, setPhotos] = useState([]);
    useEffect(() => {
        getPhotos().then(setPhotos).then()
        
    }, []);
    return (
        <div className='block_7'>
          <h2>{text["title_7"][lang]}</h2>
          <h6>{text["subtitle_7"][lang]}</h6>
          <div  className="swiper_desktop">
            <Swiper
                modules={[Pagination]}
                navigation={true}
                autoplay={false}
                pagination={{
                    clickable: true,
                }}
                loop={true}
                spaceBetween={40}
                slidesPerView={3}
                slidesPerGroup={3}
            >
            {photos.map(photo => 
                <SwiperSlide key={photo._id}>
                    <Photo img={photo.img} />
                </SwiperSlide>
            )}
            </Swiper>
          </div>
          <div className="swiper_mobile">
            <Swiper
                modules={[Pagination]}
                navigation={true}
                autoplay={false}
                pagination={{
                    clickable: true,
                }}
                loop={true}
                spaceBetween={40}
                slidesPerView={1}
                slidesPerGroup={1}
            >
            {photos.map(photo => 
                <SwiperSlide key={photo._id}>
                    <Photo img={photo.img} />
                </SwiperSlide>
            )}
            </Swiper>        
          </div>
        </div>
    )
}



export default Photos;